import label from "@/lang/StaticLabels.js";

// PMRP Router  - بهای تمام شده -----------------------------------------------
let routeItems = {
  path: "PMRP",
  name: "PMRP",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PMRPDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PMRPDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pmrp,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrp/Dashboard"),
    },

    // Base Information -----------------------------------------------

    {
      path: "bom",
      name: "PMRPBOM",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/combinedBom/list",
      children: [
        {
          path: "combinedBomList",
          name: "PMRPCombinedBomList",
          component: () => import("@/views/modules/pmrp/base/combinedBom"),
          meta: {
            label: label.page.bom,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PMRPAddCombinedBom",
          meta: {
            label: label.page.addBom,
            requiresAuth: true,
          },
          component: () => import("@/views/modules/pmrp/base/combinedBom/Add"),
        },
        {
          path: "edit/:id",
          name: "PMRPEditCombinedBom",
          component: () => import("@/views/modules/pmrp/base/combinedBom/Add"),
          meta: {
            label: label.page.editBom,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "systemSetting",
      name: "PMRPSystemSetting",
      meta: {
        label: label.page.settings,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrp/base/systemSetting"),
    },
    {
      path: "settingTransactions",
      name: "PWHRSSettingTransactions",
      meta: {
        label: label.page.settingTransactions,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrp/base/transactionInfo"),
    },
    // Operation -----------------------------------------------
    {
      path: "production",
      name: "PMRPProduction",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/production/list",
      children: [
        {
          path: "list",
          name: "PMRPCombinedProduction",
          component: () => import("@/views/modules/pmrp/operation/production"),
          meta: {
            label: label.page.production,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PMRPAddProduction",
          meta: {
            label: label.page.addProduction,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pmrp/operation/production/Add"),
        },
        {
          path: "edit/:id",
          name: "PMRPEditProduction",
          component: () =>
            import("@/views/modules/pmrp/operation/production/Add"),
          meta: {
            label: label.page.editProduction,
            requiresAuth: true,
          },
        },
      ],
    },
    //  Reports -----------------------------------------------
    {
      path: "productionDetailReports",
      name: "PMRPProductionDetailReports",
      component: () => import("@/views/modules/pmrp/reports/productionDetails"),
      meta: {
        label: label.page.microProductionReport,
        requiresAuth: true,
      },
    },
    {
      path: "consumablesReports",
      name: "PMRPConsumablesReports",
      component: () => import("@/views/modules/pmrp/reports/consumablesReport"),
      meta: {
        label: label.page.consumablesReport,
        requiresAuth: true,
      },
    },
    {
      path: "productionCostReports",
      name: "PMRPProductionCostReports",
      component: () => import("@/views/modules/pmrp/reports/productionCost"),
      meta: {
        label: label.page.productionCostReport,
        requiresAuth: true,
      },
    },
  ],
};

export default routeItems;
